 
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable,of } from 'rxjs';
import { AutoSliderItem } from '../model/auto-slider';
 
@Injectable({
  providedIn: 'root'
})
export class AutoSliderImagesService {
   
  constructor(private http: HttpClient) { } 
  getImagesSaude(): Observable<AutoSliderItem[]> {
    return of([
      {
        imageUrl: '../../../../../assets/app-assets/images/logos-empresas/externos/logos-company/unimed-fesp.png',
        height: 100, width: 250, alt: 'unimed fesp'
      },
      {
        imageUrl: '../../../../../assets/app-assets/images/logos-empresas/externos/logos-company/plena.png',
        height: 100, width: 250, alt: 'Plena'
      },
      {
        imageUrl: '../../../../../assets/app-assets/images/logos-empresas/externos/logos-company/preventsenior.png',
        height: 100, width: 250, alt: 'preventsenior'
      },
      {
        imageUrl: '../../../../../assets/app-assets/images/logos-empresas/externos/logos-company/biovida.png',
        height: 100, width: 250, alt: 'biovida'
      },
      {
        imageUrl: '../../../../../assets/app-assets/images/logos-empresas/externos/logos-company/amil.png',
        height: 100, width: 250, alt: 'amil'
      },
      {
        imageUrl: '../../../../../assets/app-assets/images/logos-empresas/externos/logos-company/aacl.png',
        height: 100, width: 250, alt: 'aacl'
      }, 
     ]);
  }

  getImagesSeguro(): Observable<AutoSliderItem[]> {
    return of([
      {
        imageUrl: '../../../../../assets/app-assets/images/logos-empresas/externos/logos-company/portoseguro.png',
        height: 100, width: 250, alt: 'portoseguro'
      },
      {
        imageUrl: '../../../../../assets/app-assets/images/logos-empresas/externos/logos-company/mapre.png',
        height: 100, width: 250, alt: 'mapre'
      },
      {
        imageUrl: '../../../../../assets/app-assets/images/logos-empresas/externos/logos-company/shuaia.png',
        height: 100, width: 250, alt: 'shuaia'
      },
      {
        imageUrl: '../../../../../assets/app-assets/images/logos-empresas/externos/logos-company/bradescoseguro.png',
        height: 100, width: 250, alt: 'bradescoseguro'
      },
      {
        imageUrl: '../../../../../assets/app-assets/images/logos-empresas/externos/logos-company/tokio.png',
        height: 100, width: 250, alt: 'tokio'
      },
      {
        imageUrl: '../../../../../assets/app-assets/images/logos-empresas/externos/logos-company/azulseguros.png',
        height: 100, width: 250, alt: 'azulseguros'
      }, 
     ]);
  }
  getImagesOdonto(): Observable<AutoSliderItem[]> {
    return of([
      {
        imageUrl: '../../../../../assets/app-assets/images/logos-empresas/externos/logos-company/unimedOdonto.png',
        height: 100, width: 250, alt: 'unimedOdonto'
      },
      {
        imageUrl: '../../../../../assets/app-assets/images/logos-empresas/externos/logos-company/odontoprev.png',
        height: 100, width: 250, alt: 'odontoprev'
      },
      {
        imageUrl: '../../../../../assets/app-assets/images/logos-empresas/externos/logos-company/uniodonto.png',
        height: 100, width: 250, alt: 'uniodonto'
      },
      {
        imageUrl: '../../../../../assets/app-assets/images/logos-empresas/externos/logos-company/amildental.png',
        height: 100, width: 250, alt: 'amildental'
      },
      {
        imageUrl: '../../../../../assets/app-assets/images/logos-empresas/externos/logos-company/sulamericaodonto.png',
        height: 100, width: 250, alt: 'sulamericaodonto'
      },
      {
        imageUrl: '../../../../../assets/app-assets/images/logos-empresas/externos/logos-company/bradescodental.png',
        height: 100, width: 250, alt: 'bradescodental'
      }, 
     ]);
  }
}


 